/**
 * `symbolPickerColumnsV2` — the symbol / value picker opens the columns popup
 * (symbol-picker-popup.tsx, on the shared column engine) instead of antd's Cascader. ON by default
 * (KOA-18648); the switches below exist to turn it OFF (back to the Cascader) or to force it on.
 *
 * Two switches, the first that says anything wins:
 *  1. Per browser: `localStorage["kuika.symbolPickerColumnsV2"]` = "true" / "false". For going back
 *     to the Cascader locally or on a test environment without a deploy:
 *       localStorage.setItem("kuika.symbolPickerColumnsV2", "false"); location.reload();
 *  2. Per deployment: `window._env_.SYMBOL_PICKER_COLUMNS_V2` = "true" / "1" (env-config.js, which
 *     env.sh writes from the container env — the variable must be added to env.sh's list to be
 *     honoured in a container).
 *
 * Absent, empty or unrecognised means ON: the columns popup is what a deployment gets when nobody
 * decided. The flag is read once per picker mount; flipping it takes effect on reload.
 */

export const SYMBOL_PICKER_COLUMNS_V2_STORAGE_KEY: string = "kuika.symbolPickerColumnsV2";

function parseSwitch(raw: string | null | undefined): boolean | undefined {
  if (raw === null || raw === undefined) {
    return undefined;
  }
  const value: string = raw.trim().toLowerCase();
  if (value === "true" || value === "1") {
    return true;
  }
  if (value === "false" || value === "0") {
    return false;
  }
  return undefined;
}

function readStorageSwitch(): boolean | undefined {
  try {
    return parseSwitch(window.localStorage.getItem(SYMBOL_PICKER_COLUMNS_V2_STORAGE_KEY));
  } catch {
    // Storage blocked (private mode, sandboxed frame): fall through to the deployment switch.
    return undefined;
  }
}

export function isSymbolPickerColumnsV2Enabled(): boolean {
  const fromStorage: boolean | undefined = readStorageSwitch();
  if (fromStorage !== undefined) {
    return fromStorage;
  }
  return parseSwitch(window._env_?.SYMBOL_PICKER_COLUMNS_V2) !== false;
}
